import { SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import {
  IStaleRouteCompanyStat,
  type IProduceLogsCleanupBulkResult,
} from "../models/admin-tools.models";
import { IApiDevVersion, IEnvFlagsDto } from "../models/pages.models";

export class ControlsApi {
  static async clearInProduceBookingsCache(): Promise<
    SimpleResult<void> | undefined
  > {
    const companyId = getCompanyId();

    const requestUrl = `/api/v1/core/c/${companyId}/production/clear-in-produce-bookings-cache`;
    const response = await Api.post<SimpleResult<void>>(requestUrl);

    return response?.data;
  }

  static async clearInProduceBookingsCacheForCompany(
    companyId: number,
  ): Promise<SimpleResult<void> | undefined> {
    const requestUrl = `/api/v1/core/c/${companyId}/production/clear-in-produce-bookings-cache`;
    const response = await Api.post<SimpleResult<void>>(requestUrl);

    return response?.data;
  }

  static async getApiDevVersion(): Promise<IApiDevVersion | undefined> {
    const requestUrl = `/api/v1/core/info/api-dev-version`;
    const response = await Api.get<IApiDevVersion>(requestUrl);

    return response?.data;
  }

  static async getEnvFlags(): Promise<IEnvFlagsDto | undefined> {
    const requestUrl = `/api/v1/core/info/env-flags`;
    const response = await Api.get<IEnvFlagsDto>(requestUrl);

    return response?.data;
  }

  static async clearStaleRoutes(): Promise<SimpleResult<number> | undefined> {
    const companyId = getCompanyId();

    const requestUrl = `/api/v1/core/c/${companyId}/admin-tools/clear-stale-routes`;
    const response = await Api.post<SimpleResult<number>>(requestUrl);

    return response?.data;
  }

  static async clearStaleRoutesForCompany(
    companyId: number,
  ): Promise<SimpleResult<number> | undefined> {
    const requestUrl = `/api/v1/core/c/${companyId}/admin-tools/clear-stale-routes`;
    const response = await Api.post<SimpleResult<number>>(requestUrl);

    return response?.data;
  }

  static async clearStaleRoutesAllCompanies(): Promise<
    SimpleResult<number> | undefined
  > {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/admin-tools/clear-stale-routes-all`;
    const response = await Api.post<SimpleResult<number>>(requestUrl);

    return response?.data;
  }

  static async getStaleRoutesStats(): Promise<
    SimpleResult<IStaleRouteCompanyStat[]> | undefined
  > {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/admin-tools/stale-routes-stats`;
    const response =
      await Api.get<SimpleResult<IStaleRouteCompanyStat[]>>(requestUrl);

    return response?.data;
  }

  static async clearOldProduceLogsForCompany(
    companyId: number,
    retentionDays: number,
  ): Promise<SimpleResult<IProduceLogsCleanupBulkResult> | undefined> {
    const requestUrl = `/api/v1/core/c/${companyId}/admin-tools/clear-old-produce-logs?retentionDays=${retentionDays}`;
    const response =
      await Api.post<SimpleResult<IProduceLogsCleanupBulkResult>>(requestUrl);

    return response?.data;
  }

  static async clearOldProduceLogsAllCompanies(
    retentionDays: number,
  ): Promise<SimpleResult<IProduceLogsCleanupBulkResult> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/admin-tools/clear-old-produce-logs-all?retentionDays=${retentionDays}`;
    const response =
      await Api.post<SimpleResult<IProduceLogsCleanupBulkResult>>(requestUrl);

    return response?.data;
  }
}
